module.exports = __webpack_public_path__ + "img/31.818c068a.jpg";